type StudentLike = {
  first_name?: string
  firstName?: string
  given_name?: string
  name?: string
  last_name?: string
  lastName?: string
  family_name?: string
}

export const getStudentName = (user: StudentLike | null | undefined) => {
  if (!user) {
    return {
      firstName: 'Student',
      lastName: '',
      fullName: 'Student'
    }
  }

  const firstName =
    user.first_name || user.firstName || user.given_name || user.name || ''
  const lastName = user.last_name || user.lastName || user.family_name || ''
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim()

  return {
    firstName: firstName || 'Student',
    lastName,
    fullName: fullName || 'Student'
  }
}

export const getStudentInitials = (user: StudentLike | null | undefined) => {
  const { fullName } = getStudentName(user)

  const initials = fullName
    .split(' ')
    .filter(Boolean)
    .map((name) => name[0])
    .join('')
    .toUpperCase()

  return initials || 'ST'
}
